export default {
  getGruposRamais: state => state.gruposRamais,
  getGrupoRamalSelecionado: state => state.grupoRamalSelecionado,
  getRamais: state => state.ramais,
}
